import { createStyles, ScrollArea, Stack } from '@mantine/core';
import { trackEvent } from '@repo/common/analytics';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useAuthUser } from '../../../../../api';
import EntityDrawerHeader from '../../../../../components/EntityDrawer/components/EntityDrawerHeader';
import { getEntityPageSidebarProps } from '../../../../../components/EntityDrawer/utils';
import EntitySidebarContent from '../../../../../components/EntityPageLayout/EntitySidebarContent';
import type { SidebarEntityKeys } from '../../../../../components/EntityPageLayout/types';
import type { DjangoValueType } from '../../../../TemplatePage/types';
import policyIssueDrawerStore from '../store';
import EntityActionBar from './EntityActionBar';

const useStyles = createStyles(() => ({
	asideWrapper: {
		border: 'none',
		overflow: 'inherit',
	},
	sidebarWrapper: {
		overflow: 'hidden',
	},
}));

export const PolicyIssueEntityContent = observer(() => {
	const { classes } = useStyles();
	const { user, workspace } = useAuthUser();

	const update = useCallback(
		(
			key: SidebarEntityKeys,
			value: DjangoValueType,
			saveRemotely?: boolean
		) => {
			trackEvent(
				`${policyIssueDrawerStore.entity.entity_type}/${key}/update`,
				{ id: policyIssueDrawerStore.entity.id },
				user!,
				workspace
			);
			policyIssueDrawerStore.updateEntity(key, value, saveRemotely);
		},
		[user, workspace]
	);

	return (
		<Stack spacing={0}>
			<EntityActionBar />
			<Stack className={classes.sidebarWrapper} pt={0} spacing={0}>
				<EntityDrawerHeader
					entityType={policyIssueDrawerStore.entity.entity_type}
					store={policyIssueDrawerStore}
					padding="xl"
				/>
				<ScrollArea>
					<Stack className={classes.asideWrapper} spacing={0} p={0}>
						<EntitySidebarContent
							entity={policyIssueDrawerStore.entity}
							updateEntity={update}
							{...getEntityPageSidebarProps(
								policyIssueDrawerStore.entity.entity_type
							)}
						/>
					</Stack>
				</ScrollArea>
			</Stack>
		</Stack>
	);
});
